import React from 'react';
import { ChevronIcon } from '../../assets';
import { PropTypes } from 'prop-types';

const Pagination = ({
  totalPage,
  currentPage,
  setCurrentPage,
  navigablePages,
  displayPage,
}) => {
  const useNavSequence =
    Array.isArray(navigablePages) && navigablePages.length > 0;

  const labelPage =
    displayPage !== undefined && displayPage !== null ? displayPage : currentPage;

  const canGoPrev = useNavSequence
    ? navigablePages.some(p => p < currentPage)
    : currentPage > 1;

  const canGoNext = useNavSequence
    ? navigablePages.some(p => p > currentPage)
    : currentPage < totalPage;

  const handlePrev = () => {
    if (!canGoPrev) {
      return;
    }
    if (useNavSequence) {
      const eligible = navigablePages.filter(p => p < currentPage);
      setCurrentPage(eligible[eligible.length - 1]);
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (!canGoNext) {
      return;
    }
    if (useNavSequence) {
      setCurrentPage(navigablePages.find(p => p > currentPage));
    } else {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div
      className="grid grid-cols-4 gap-2 h-44px"
      data-testid="test-right-sidebar-pagination"
    >
      <div
        className="col-span-1 flex justify-end items-center"
        data-testid="test-check-icon-left"
        onClick={handlePrev}
      >
        <div className="rotate-90" data-testid="test-check-icon">
          <ChevronIcon />
        </div>
      </div>
      <div className="col-span-2 flex justify-center items-center">{`Page ${labelPage}`}</div>
      <div
        className="col-span-1 flex justify-start items-center"
        data-testid="test-check-icon-right"
        onClick={handleNext}
      >
        <div className="rotate-90">
          <div className="rotate-180">
            <ChevronIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  totalPage: PropTypes.number.isRequired,
  navigablePages: PropTypes.arrayOf(PropTypes.number),
  displayPage: PropTypes.number,
};

export default Pagination;
